import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Legal from "../pages/legal/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/privacy-and-terms",
    element: <Legal />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;